<template>
  <div>
    <md-list>
      <md-subheader>{{title}} - {{competitors.length}}</md-subheader>
      <md-list-item v-for="competitor in competitors" :key="competitor.id">
        <Competitor :tournament="tournament" :competitor="competitor"/>
      </md-list-item>
    </md-list>
    <p></p>
  </div>
</template>

<script>
import Competitor from "./competitor.vue";

export default {
  name: "CompetitorList",
  props: { title: String, competitors: Array, tournament: Object },
  components: { Competitor }
};
</script>

<style lang="scss" scoped>
.md-list {
  width: 320px;
  display: inline-block;
  overflow: auto;
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// competitorList.vue?353e0e21